<template>
  <div>
    <document-input :recipient="recipient" />
    <name-input :recipient="recipient" />
    <birthdate-input :recipient="recipient" />
    <email-input :recipient="recipient" />
    <professional-occupation-input :recipient="recipient" />
    <monthly-income-input :recipient="recipient" />
    <mother-name-input :recipient="recipient" />
    <div class="phone-container">
      <phone-type-input
        class="phone-type"
        :recipient="recipient"
        :disabled="disabled"
      />
      <phone-area-number-input
        class="phone-area"
        :recipient="recipient"
        :disabled="disabled"
      />
      <phone-number-input
        class="phone-number"
        :recipient="recipient"
        :disabled="disabled"
      />
    </div>
    <hr class="emd-divider eu-mb_5" />
    <address-section
      :recipient="recipient"
      :showSideBlock="false"
    />
  </div>
</template>
<script>
import {
  DocumentInput,
  NameInput,
  BirthdateInput,
  EmailInput,
  ProfessionalOccupationInput,
  MonthlyIncomeInput,
  MotherNameInput,
  PhoneTypeInput,
  PhoneAreaNumberInput,
  PhoneNumberInput
} from './FormFields'
import AddressSection from './AddressSection.vue'
export default {
  name: 'ManagingPartner',
  components: {
    DocumentInput,
    NameInput,
    BirthdateInput,
    EmailInput,
    ProfessionalOccupationInput,
    MonthlyIncomeInput,
    AddressSection,
    MotherNameInput,
    PhoneTypeInput,
    PhoneAreaNumberInput,
    PhoneNumberInput
  },
  props: {
    recipient: {
      type: Object,
      required: true
    },
    disabled: Boolean
  }
}
</script>
<style scoped>
.phone-container {
  display: flex;
  gap: 16px;
}
.phone-type {
  width: 125px;
  text-wrap: nowrap;
}
.phone-area {
  width: 65px;
}
.phone-number {
  width: 100%;
}
</style>

<i18n>
  {
    "pt-BR": {
      "managing-partners": "Sócios",
      "managing-partner": "Sócio {number}"
    },
    "en-US": {
      "managing-partners": "Managing partners",
      "managing-partner": "Managing Partner {number}"
    }
  }
</i18n>
